export default {
	meta: {
		title: 'Experience patient',
		description: 'Experience patient'
	},
	noCampaign: 'Vous n\'avez pas encore de campagne'
};